import { Component, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-modern-header',
  templateUrl: './modern-header.component.html',
  styleUrls: ['./modern-header.component.scss'],
})
export class ModernHeaderComponent implements OnInit {
  phoneNumber: string = '+1234567890'; // Default phone number
  telLink: string = '';
  langChangeSub: Subscription;
  constructor(private translate: TranslateService) {}

  ngOnInit() {
    this.updateTelLink();

    // Listen for language changes
    this.langChangeSub = this.translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.updateTelLink();
      }
    );
  }

  updateTelLink() {
    // Optional: Get phone number from a translation file if needed
    const translatedPhone =
      this.translate.instant('callToUsPhone') || this.phoneNumber;
    const sanitized = translatedPhone.replace(/[^+\d]/g, '');
    this.telLink = `tel:${sanitized}`;
  }

  ngOnDestroy() {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }
}
